import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    position: "relative",
    "& .MuiIconButton-root": {
      padding: 0,
    },
  },
  input: {
    display: "none",
  },
  inputLabel: {
    display: "flex",
    borderBottom: "solid 1px #CBCBCB",
    position: "relative",
    "& .MuiFormControl-root": {
      width: "100%",
      justifyContent: "flex-end",
      paddingLeft: 24,
      cursor: "pointer",
    },
    "& .MuiInputBase-input": {
      fontSize: 14,
      marginBottom: "-1px",
      fontWeight: 500,
    },
    "& .MuiIconButton-root": {
      marginTop: 18,
      position: "absolute",
      width: "100%",
      // zIndex: 1,
      borderRadius: 0,
      display: "flex",
      justifyContent: "flex-start",
      [theme.breakpoints.down("xs")]: {
        marginTop: 2,
      },
      "&:hover": {
        background: "transparent",
      },
    },
    "& .MuiInput-underline.Mui-disabled:before": {
      border: "none",
    },
    "& .MuiInput-root": {
      color: "#202f43 !important",
    },
  },
  uploadBtnLabel: {
    fontSize: 12,
    padding: 0,
    margin: 0,
    position: "absolute",
    [theme.breakpoints.down("xs")]: {
      position: "unset",
    },
  },
  errorMessages: {
    color: "#F36F6F",
    fontSize: 13,
    marginTop: 3,
    display: "flex",
    "& svg": {
      fontSize: 18,
    },
  },
}));

export default useStyles;
